<template>
    <list
        :empty-message="emptyMessage"
        :listRoute="listRoute"
        :label="label"
        :excluded-ids="excludedIds"
        :excluded-documents="excludedDocuments"
        :multiple="multiple"
        :selected="selected"
        :language="language"
        :full-width="fullWidth"
        :show-select-all="showSelectAll"
        @selected="selectObject"
        @deselect-all="$emit('deselect-all')"
        @select-all="(selectAllObjects) => $emit('select-all', selectAllObjects)"
        @list-loaded="(listCount) => $emit('list-loaded', listCount)"
        :list-data="listData"
        :max-items="maxItems"
        :query="query"
        :order="order"
        :with-docs="withDocs"
        :parent="parent"
    />
</template>
<script>
export default {
    name: "ModelList",
    props: {
        label: String,
        listRoute: String,
        emptyMessage: {
            type: String,
            required: false
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        showSelectAll: {
            type: Boolean,
            default: false,
        },
        maxItems: Number,
        excludedIds: Array,
        excludedDocuments: Array,
        listData: Array,
        multiple: Boolean,
        language: Object,
        selected: {
            type: Array,
            default: () => [],
        },
        query: Object,
        order: Object,
        withDocs: {
            type: Array,
            required: false
        },
        parent: Object
    },
};
</script>
